import { render, staticRenderFns } from "./CloudFloatReturn.vue?vue&type=template&id=ef3fd2e6&"
import script from "./CloudFloatReturn.vue?vue&type=script&lang=js&"
export * from "./CloudFloatReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports